import { PlusOutlined } from "@ant-design/icons"
import { Button, Popconfirm, Space } from "antd"
import classNames from "classnames"
import { CreateSpreadsheetModal } from "./CreateSpreadsheetModal"
import { useSelector } from "react-redux"
import { addSpreadsheet, getSpreadsheets, getTopologyState, removeSpreadsheet, updateSpreadsheet } from "@/store/flowsheet/flowsheet.slice"
import { useDispatch } from "react-redux"
import { v4 as uuidv4 } from "uuid";
import { SpreadsheetDialog } from "./Spreadsheets"
import { Spreadsheet } from "@/components/FlowSheetEditor/services/modal"


interface SpreadsheetPanelProps {
  onChange?: () => void
}
export const SpreadsheetPanel = (props: SpreadsheetPanelProps) => {
  const {onChange} = props;
  const spreadsheets = useSelector(getSpreadsheets)
  const dispatch = useDispatch()

  const onSave = (val) => {
    if (val.id) {
      dispatch(updateSpreadsheet(val))
      return;
    }
    dispatch(addSpreadsheet({
      id: uuidv4(),
      data: [],
      ...val,
    }))
  }

  const onDelete = (id: string) => {
    dispatch(removeSpreadsheet(id))
    onChange?.()
  }

  const onSheetDataChange = (data: any, item: Spreadsheet, autoUpdate = false) => {
    dispatch(updateSpreadsheet({...item, data}))
    if (autoUpdate) {
      onChange?.()
    }
  }

  return <div style={{width: '100%'}}>
    <div className="unit-container">
      <div className={classNames('unit-header', 'flex-space-btw')}>
        <div>Spreadsheets</div>
      </div>
      <div>
        <div className="p-1 mt-1 flex-end">
          <Button
            onClick={() => CreateSpreadsheetModal.show({onSuccess: onSave})}
            type='primary' size="small" icon={<PlusOutlined />}>Add</Button>
        </div>
        <table style={{width: '100%'}} className="bordered-table break-word-table table-mt">
          <thead>

            <tr>
              <th scope="col" style={{width: '50%'}}>Name</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {spreadsheets.map((item) => {
              return <tr key={item.id}>
                <td>{item.tag}</td>
                <td>
                  <Space>
                    <SpreadsheetDialog spreadsheet={item} data={item.data} onSave={(data, autoUpdate) => onSheetDataChange(data, item, autoUpdate)} />
                    <Button
                      type="link"
                      size="small"
                      onClick={() => {
                        CreateSpreadsheetModal.show({onSuccess: onSave, spreadsheet: item})
                      }}>Edit</Button>
                      <Popconfirm
                        title="Delete the spreadsheet"
                        description="Are you sure to delete this spreadsheet?"
                        onConfirm={() => onDelete(item.id)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button type="link" size="small" danger>Delete</Button>
                      </Popconfirm>
                    
                  </Space>
                </td>
              </tr>
            })}
            
          </tbody>
        </table>
      </div>
    </div>
  </div>
}